var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page-header"},[_c('h1',{staticClass:"page--heading mb-2"},[_vm._t("title")],2),(_vm.pageDescription)?_c('p',{staticClass:"page--description mb-5 pb-3"},[_vm._v(_vm._s(_vm.pageDescription))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }